import React, { useState, useEffect } from "react";
import { SFCarouselContainer } from "@sf-core";
import { SFTypography, SFStack, getStyled } from "@sf-core";
import { getSigninSlides } from "../../services/contentService";
import { Box } from "@mui/material";

const { styled } = getStyled();

const StyledStack = styled(SFStack)(({ theme }) => ({
  textAlign: "center",
  margin: theme.spacing(0.5),
}));

const Item = ({ image, title, caption }) => (
  <StyledStack
    alignItems="center"
    justifyContent="center"
  >
    <SFTypography variant="h2" component="div">
      <img src={image} sx={{ minWidth: "100%" }} />
    </SFTypography>
    <SFTypography
      variant="h2"
      component="h2"
      sx={{ fontSize: 20, width: "80%" }}
    >
      {title}
    </SFTypography>
    <SFTypography
      variant="body1"
      sx={{ maxWidth: 400, fontSize: 16, width: "80%" }}
    >
      {caption}
    </SFTypography>
  </StyledStack>
);

const SignInCarousel = () => {
  const [items, setItems] = useState({ loading: true });

  useEffect(() => {
    getSigninSlides().then((r) => setItems(r.data));
  }, []);

  if (items.loading) {
    return (
      <Box sx={{ display: "flex" }}>
        {/* <CircularProgress /> */}
      </Box>
    );
  }

  const options = {
    type: "loop",
    rewind: true,
    width: "100%",
    gap: 20,
    perMove: 1,
    perPage: 1,
    autoplay: true,
    pauseOnHover: false,
    interval: 5000,
    speed: 1000,
    pagination: true,
    padding: { left: 10, right: 10, top: 10, bottom: 10},
    arrows: false,
  };

  return (
    <SFCarouselContainer options={options}>
      {items.map((step, index) => (
        <Item key={index} image={step.image} title={step.title} caption={step.caption} />
      ))}
    </SFCarouselContainer>
  );
};

export default SignInCarousel;
